/** Supporting-component badge / compact label. */

import { resolveProposalSupportingComponentLabel } from "../proposalLinePresentation";
import type { DtoolsStagingLine } from "../dtoolsJsonStaging";

export const SUPPORTING_COMPONENT_BADGE = "Supporting Component";

export function renderSupportingComponentLabel(line: DtoolsStagingLine): string {
  return resolveProposalSupportingComponentLabel(line);
}

export function renderSupportingComponentBadge(isAccessory: boolean): string | null {
  return isAccessory ? SUPPORTING_COMPONENT_BADGE : null;
}
